<template>
<!-- 销售管理 -->
<el-dialog title="绑定的外部商户" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
    <div class="dialog-form">
        <!-- <i class="el-icon-plus"></i> -->
        <el-table :data="staffData" style="width: 100%">
            <el-table-column prop="title" label="商户名"></el-table-column>
            <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                    <div>
                        <el-button type="primary" @click="unbindStaff(scope.row)">解绑</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>

</el-dialog>
</template>

<script>
export default {
    components: {

    },
    data() {
        return {
            hotel_id: 0,
            dialogVisible: false,
            staffData: [],
        };
    },
    methods: {
        // 销售管理
        show(row) {
            this.user_id = row.id;
            this.dialogVisible = true;
            this.getBindedStaff(row.id);
        },
        getBindedStaff(userId) {
            let url = '/api/merchant.bind/userCompany';
            this.$post(url, {
                user_id: userId
            }).then(res => {
                this.staffData = res.data.list;
            });
        },
        // 删除销售
        unbindStaff(row) {
            let _this = this;
            this.$confirm('确定解绑此商户吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                .then(() => {
                    let url = '/api/merchant.bind/unbindUserCompany';
                    _this.$post(url, {
                        user_id: this.user_id,
                        hotel_id: row.id,
                    }).then(res => {
                        _this.staffData.forEach((item, key) => {
                            if (row.id == item.id) {
                                _this.staffData.splice(key, 1);
                            }
                        });

                        _this.$message({
                            type: 'success',
                            message: res.msg
                        });
                    });
                })
                .catch(() => {
                    _this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        handleClose() {
            this.dialogVisible = false;
        }
    }
}
</script>

<style lang="less" scoped>
@import url('@/assets/css/drawer.less');

.dialog-form {
    min-height: 400px;
}
</style>
